import { hits, configure } from 'instantsearch.js/es/widgets'
import { getInstance, registerWidget } from "./algolia-create-instance";
import { renderHitTemplate as fallbackTemplate } from "../../hits-templates/default-template.js"

document.addEventListener("DOMContentLoaded", function() {
  const tgblAlgoliaHitsDataJSON = window.atob(tgblAlgoliaEncodedHitsData);
  const tgblAlgoliaHitsData = jQuery.parseJSON(tgblAlgoliaHitsDataJSON);
  
  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaHitsData.localized;

  const templatePath = tgblAlgoliaHitsData.templatePath

  const elements = document.querySelectorAll("[data-filter-type='hits']")
  const elementsArray = Array.from(elements);
  
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      elementsWithSameIndex.forEach(async element => {

        let renderHitTemplate = fallbackTemplate

        if(templatePath) {
          try{
            const module = await import(templatePath)
            renderHitTemplate = module.default || module.renderHitTemplate
          } catch (error) {
            console.error(`Error loading template from ${templatePath}:`, error)
          }
        }
        
        let AlgoliaHits = ($, search, element) => {
          search.addWidgets([
            hits({
              container: element,
              templates: {
                item: (hit, {html, component}) => {
                  const template = renderHitTemplate(hit, {html, component})
                  const event = new CustomEvent('algoliaRenderTemplate', {})
                  window.dispatchEvent(event)
                  return template
                },
              },
              cssClasses: {
                list: ['tgblAlgolia-grid', 'tgblAlgolia-grid--density-16'],
                item: ['tgblAlgolia-card tgblAlgolia-card--is-style-elevated tgblAlgolia-card--has-interaction'],
              },
            }),
          ]);
          registerWidget(element);
        };
        AlgoliaHits($, search, element);
      });
    }
  }
});